import MessageLoader from 'common/MessageLoader'
import classNames from 'classnames'

interface PageLoaderComponentOverrides {
  Empty?: JSX.Element
  Loading?: JSX.Element
  Error?: JSX.Element
}

interface PageLoaderProps {
  isLoading: boolean
  error?: string | undefined
  isEmpty?: boolean
  loadingMessage?: string
  emptyMessage?: string
  Components?: PageLoaderComponentOverrides
  loadingContainerClass?: string
  emptyContainerClass?: string
  withSkeleton?: boolean
}

/*
 * This component handles these page states while making a API call, Loading, Error, Empty
 * This would mostly be used when there is a component where content of it would depends on the API data
 * And this component would handle displaying those states on the UI side till the data is loaded
 */
const PageLoader: React.FC<PageLoaderProps> = ({
  isLoading,
  isEmpty,
  error,
  loadingMessage = 'Loading...',
  emptyMessage = 'No records found.',
  Components,
  children,
  loadingContainerClass,
  emptyContainerClass = '',
  withSkeleton = false,
}) => {
  const pageStateContainerClass = withSkeleton ? '' : '~flex-1 flex-center'

  if (isLoading) {
    return (
      <div className={`${loadingContainerClass} ${pageStateContainerClass}`}>
        {Components?.Loading || <MessageLoader message={loadingMessage} />}
      </div>
    )
  }

  if (error) {
    return (
      Components?.Error || (
        <div className="~flex-1">
          <div
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            className="~bg-[#f8d7da] ~border ~border-[#f5c2c7] ~text-[#842029] ~rounded ~p-3 ~text-center"
          >
            {error}
          </div>
        </div>
      )
    )
  }

  if (isEmpty) {
    return (
      <div className={classNames(emptyContainerClass, pageStateContainerClass)}>
        {Components?.Empty || (
          <span className="width-18 fs-18 ~font-bold ~text-center">
            {emptyMessage}
          </span>
        )}
      </div>
    )
  }

  return <>{children}</>
}

export default PageLoader
